const airplane = {
    getlist: 'airplane/getlist',
    add: 'airplane/add',
    update: 'airplane/update',
    remove: 'airplane/remove',
    get: 'airplane/get',
    getall: 'airplane/getall',
    clearcache: 'airplane/clear-cache',
}
export default airplane
